import React, { useState, useEffect } from "react";
import { useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate, useLocation } from 'react-router-dom';
import electricalswitch from "./images/electricalswitch.webp";
import CPVCpipes from "./images/CPVCpipes.png";
import MenuFooter from "./Component/MenuFooter";
import { Wallet, ShoppingBag } from "lucide-react";
import constructionimg from "./images/constructionimg.png";
import cart from "./images/cartimg.jpg";
import { FaChevronDown, FaMapMarkerAlt, FaPlusCircle } from "react-icons/fa";
import listicon from "./images/listicon.webp";
import { Loader2 } from "lucide-react";
import Microphone from './images/Microphone.png';
import ChangeLocationPopup from "./Component/ChangeLocationPopup";
import { faBox ,faUserCircle, faImage,  faWallet,  faAngleRight,  faShoppingBag,  faIndianRupee,
 faCoins,  faIndianRupeeSign,
  faCheckCircle,  faClock,
  faExclamationTriangle,
} from "@fortawesome/free-solid-svg-icons";
import { useNotification } from '../context/NotificationContext';
import UMR from './UMR';
import ProjectQuoteModal from "./ProjectQuoteModal"; 
import ViewBucket from './Component/ViewBucket';
import ProductSearchOverlay from "./Component/ProductSearchoverlay";
import BCImg from "./images/buildcoin.png"; 
import Bucket from "./images/Gray_Bucket.png"
import defaultimg from "./images/defaultimg.png";
const sampleWallet = {
  balance: 5000,
  expiring: { amount: 500, days: 30 },
  freeRfqLeft: 2,
};
const sampleStats = {
  ordersValue: 125000,
  totalSavings: 6000,
};


function ProjectDetails() {
   const [wallet,setWallet] = useState({});
    const [stats] = useState(sampleStats);
    const navigate = useNavigate();
    const location = useLocation();
  
    const [selectedRfq, setSelectedRfq] = useState(null);
    const [loadingRfqs, setLoadingRfqs] = useState(true);
  
    const [userData, setUserData] = useState(null);
    const [customerData, setCustomerData] = useState(null);
    const [loading, setLoading] = useState(true);
      const url = process.env.REACT_APP_FORE_BRICKBUCKET; 
     const [categories, setCategories] = useState([]);
      
    const fetchUrl = process.env.REACT_APP_FORE_BRICKBUCKET;
    const [error, setError] = useState(null);
  const [showProjectPopup, setShowProjectPopup] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);
  const API_BASE = process.env.REACT_APP_FORE_BRICKBUCKET || "";
  const [liveRfqs, setLiveRfqs] = useState([]);
  const [productSubcategories, setProductSubcategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [bucketProducts, setBucketProducts] = useState({});
  const [bucketImages, setBucketImages] = useState({});
  const [QuotationDetails, setQuotationDetails] = useState([]);
  const [showCategoryPopup, setShowCategoryPopup] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [projectsList, setProjectsList] = useState([]);
  const [isListening, setIsListening] = useState(false);
  const [showVoicePopup, setShowVoicePopup] = useState(false); // ✅ new
  const showProjectQuote = sessionStorage.getItem("showProjectQuote") === "true";
  const defaultTab = location.state?.defaultTab || (showProjectQuote ? "buy" : "recent");
  const [activeTab, setActiveTab] = useState(defaultTab);   
  const [showLocationPopup, setShowLocationPopup] = useState(false);
  const [deliveryAddresses, setDeliveryAddresses] = useState([]);
   const [deliveryAddress, setDeliveryAddress] = useState(null); 
   const { notifications, setNotifications } = useNotification();
     const [showUMR, setShowUMR] = useState(false);
     const [isQuoteModalVisible, setIsQuoteModalVisible] = useState(false);
     const [brands, setBrands] = useState([]);
     const [showRfqDetails, setShowRfqDetails] = useState(false);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [isSearchFocused, setIsSearchFocused] = useState(false);
  const [quantities, setQuantities] = useState({});
  const [placeholderIndex, setPlaceholderIndex] = useState(0);
const [isProductSearchOpen, setIsProductSearchOpen] = useState(
  sessionStorage.getItem("overlayOpen") === "true"
);
  const [showViewBucket, setShowViewBucket] = useState(false);


     const [recentSearches, setRecentSearches] = useState(
    JSON.parse(sessionStorage.getItem("recentSearches") || "[]")
  );
  
  
  const placeholders = [
    "Search for Cement",
    "Search for Adhesives",
    "Search for Electrical",
    "Search for Tile Allied",
    "Search for Paint & Accessories",
    "Search for Waterproofing Chemicals",
  ];
  
  
 useEffect(() => {
   const total = placeholders.length;
   const interval = setInterval(() => {
     setPlaceholderIndex((prev) => {
       if (prev >= total) {
         setPlaceholderIndex(0);
         return 0;
       }
       return prev + 1;
     });
   }, 2000);
   return () => clearInterval(interval);
 }, [placeholders.length]);

 
useEffect(() => {
  sessionStorage.setItem("overlayOpen", isProductSearchOpen ? "true" : "false");
}, [isProductSearchOpen]);


  useEffect(() => {
         if (location.state?.triggerProjectPopup) {
           setShowProjectPopup(true);  
         }
       }, [location.state]);
  
  
         useEffect(()=>{
             if(notifications && notifications.length > 0 ){     
              fetchLiveRfqs();
            }
           },[notifications]);

  
  useEffect(() => {
    console.log("🔔 Notifications updated in ProjectDetails:", notifications);
  
    if (notifications.length > 0) {
      const userData = JSON.parse(sessionStorage.getItem("userData"));
  
      const matchingNotifications = notifications.filter((notif) => {
        const orderId1 = notif?.data?.order_id;
        const orderId2 = notif?.order_id;
        const entityId = notif?.entityId;
        const userId = notif?.recipientId;
  
        return (
          orderId1 ||
          orderId2 ||
          (entityId && userId?.toString() === userData?._id?.toString())
        );
      });
  
      if (matchingNotifications.length > 0) {
        console.log("✅ New notification affecting quotations:", matchingNotifications);
  
        fetchQuotationDetails();
      }
    }
  }, [notifications]);
  
  
  
  
  useEffect(() => {
    const savedBucketProducts = localStorage.getItem("bucketProducts");
  
    if (savedBucketProducts) {
      const products = JSON.parse(savedBucketProducts);
      setBucketProducts(products);
  
      // ✅ Build quantities and images safely
      const quantitiesObj = {};
      const imagesObj = {};
  
      Object.values(products).forEach((product) => {
        if (product && product._id) { // ✅ prevent null/undefined crash
          quantitiesObj[product._id] = product.quantity || 0;
  
          if (product.product_image) {
            imagesObj[product._id] = true;
          }
        }
      });
  
      setQuantities(quantitiesObj);
      setBucketImages(imagesObj);
    } else {
      setBucketProducts({});
      setQuantities({});
      setBucketImages({});
    }
  }, []);
  
  // Add this useEffect (listens for bucket updates, like in other components)
  useEffect(() => {
    const handleBucketUpdate = () => {
      // Re-sync states if needed (e.g., for ViewBucket reactivity)
      const saved = localStorage.getItem('bucketProducts');
      if (saved) {
        const products = JSON.parse(saved);
        setBucketProducts(products);  
        // Rebuild quantities/images as above if needed
      }
    };
  
    window.addEventListener('bucketUpdated', handleBucketUpdate);
    return () => window.removeEventListener('bucketUpdated', handleBucketUpdate);
  }, []); 
  

  useEffect(() => {
  if (!isProductSearchOpen) {
    const saved = localStorage.getItem('bucketProducts');
    if (saved) {
      const products = JSON.parse(saved);
      setBucketProducts(products);
      const quantitiesObj = {};
      const imagesObj = {};
      Object.values(products).forEach((product) => {
        if (product && product._id) {
          quantitiesObj[product._id] = product.quantity || 0;
          if (product.product_image) {
            imagesObj[product._id] = true;
          }
        }
      });
      setQuantities(quantitiesObj);
      setBucketImages(imagesObj);
    }
  }
}, [isProductSearchOpen]);
  
    const handleQuoteSubmit = (quoteData) => {
      console.log('Quote submitted:', quoteData);
      // Handle the quote submission - send to API, etc.
    };
  
  
  useEffect(() => {
    if (location.state?.defaultTab) {
      setActiveTab(location.state.defaultTab);
    }
  }, [location.state]);
    
  const startVoiceRecognition = () => {
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SpeechRecognition) {
      alert("Your browser does not support speech recognition.");
      return;
    }
  
    const recognition = new SpeechRecognition();
    recognition.lang = "en-IN";
    recognition.interimResults = false;
    recognition.maxAlternatives = 1;
  
    recognition.start();
    setIsListening(true);
    setShowVoicePopup(true); // ✅ show popup when listening starts
  
    recognition.onresult = (event) => {
      const transcript = event.results[0][0].transcript;
      setSearchQuery(transcript);
      setIsListening(false);
      setShowVoicePopup(false); // ✅ close popup after result
    };
  
    recognition.onerror = (event) => {
      console.error("Speech recognition error", event.error);
      setIsListening(false);
      setShowVoicePopup(false); // ✅ close on error
    };
  
    recognition.onend = () => {
      setIsListening(false);
      setShowVoicePopup(false); // ✅ close if ended
    };
  };
    
useEffect(() => {
      const sessionToken = sessionStorage.getItem('token');
      const localUserData = localStorage.getItem('userData');
      
      if (!sessionToken && !localUserData) {
          navigate('/consumer', { replace: true });
          return;
      }
  }, [navigate]);
  
  useEffect(() => {
    const storedBucketProducts = localStorage.getItem("bucketProducts");
    if (storedBucketProducts) setBucketProducts(JSON.parse(storedBucketProducts));
   
  }, []);
  
  
  useEffect(() => {
      const sessionToken = sessionStorage.getItem('token');
      const localUserData = localStorage.getItem('userData');
      
      if (!sessionToken && !localUserData) {
          navigate('/consumer', { replace: true });
          return;
      }
      
      if (!sessionToken && localUserData) {
          try {
              const parsedData = JSON.parse(localUserData);
              if (parsedData && parsedData.token) {
                  sessionStorage.setItem('userData', JSON.stringify(parsedData));
                  sessionStorage.setItem('token', parsedData.token);
                  sessionStorage.setItem('customerId', parsedData._id);
                  sessionStorage.setItem('organizationId', parsedData.organizationId);
                  sessionStorage.setItem('roleId', parsedData.roleId);
              } else {
                  navigate('/consumer', { replace: true });
              }
          } catch (error) {
              navigate('/consumer', { replace: true });
          }
      }
  }, [navigate]);
  
  useEffect(() => {
      const userData = JSON.parse(localStorage.getItem('userData'));
      if (userData?._id) {
          getCustomerDetails(userData._id);
          getBuildCoinsWallet();
          getDefaultDeliveryAddress(userData._id)
      }
  }, []);
  
  
  useEffect(() => {
    const fetchAllData = async () => {
      setLoading(true); // ✅ show loader once at the start
  
      try {
        const categoriesList = await fetchCategories();
        const ids = categoriesList.map((c) => c._id);
        
        if (ids.length > 0) {
          // await fetchSubcategoriesByCategoryIds(ids);
           await fetchProductsByCategoryIds(ids);
        }
  
        // Run these in parallel
        await Promise.all([
          fetchLiveRfqs(),
          //fetchRecentlyViewed(),
          //fetchQuotationDetails(),
          fetchCustomerProjects(),
          fetchAllSubcategories(),
      ]);
      } catch (err) {
        console.error("❌ Error in fetchAllData:", err);
      } finally {
        setLoading(false); 
      }
    };
  
    fetchAllData();
  }, []);
  
  useEffect(() => {
    if (isSearchFocused && Object.keys(bucketProducts).length > 0) {
      setShowViewBucket(true);  
    }
  }, [isSearchFocused, bucketProducts]);
  
  useEffect(() => {
    if (!searchQuery.trim()) {
      setSearchResults([]);
      return;
    }
  
    const query = searchQuery.toLowerCase();
  
    const allData = [
      // 🔹 Categories
      ...categories.map((cat) => ({
        type: "Category",
        id: cat._id,
        name: cat.product_category_name || "",
        image: cat.product_category_image
          ? `${process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES}${cat.product_category_image}`
          : null,
        price: null,
      })),
  
      // 🔹 Subcategories (corrected keys)
      ...productSubcategories.map((sub) => ({
        type: "Subcategory",
        id: sub._id,
        name: sub.product_sub_category_name || "",
        image: sub.product_sub_category_image
          ? `${process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES}${sub.product_sub_category_image}`
          : null,
        price: null,
      })),
  
      // 🔹 Products
      ...products.map((prod) => ({
        type: "Product",
        id: prod._id,
        name: prod.product_name || "",
        image: prod.product_image
          ? `${process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES}${prod.product_image}`
          : null,
        price: prod.selling_price ? `₹${prod.selling_price}` : null,
      })),
    ];
  
    // ✅ Filter safely (ignore empty names)
    const filtered = allData.filter(
      (item) => item.name && item.name.toLowerCase().includes(query)
    );
  
    console.log("Filtered search results:", filtered);
    setSearchResults(filtered);
  }, [searchQuery, categories, productSubcategories, products]);
  
  
  const getDefaultDeliveryAddress = async (customer_id) => {
    try {
      
      if (!customer_id) throw new Error('Customer ID is required');
  
      const url = process.env.REACT_APP_FORE_BRICKBUCKET;
      const token = sessionStorage.getItem('token');
  
      const response = await fetch(
        `${url}customer/delivery-address/getDefaultDeliveryAddress?customer_id=${customer_id}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'x-token': token,
          },
        }
      );
  
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
  
      const data = await response.json();
  
      if (data.success) {
       setDeliveryAddress(data.data)
      } else {
        console.error('Failed to fetch default delivery address:', data.message);
        return null;
      }
    } catch (error) {
      console.error('Error fetching default delivery address:', error);
      return null;
    }
  }; 
   
  const fetchAllSubcategories = async () => {
      try {
        const token = sessionStorage.getItem("token");
        const response = await fetch(
          `${fetchUrl}product-sub-category/get-all-productSubCategorys?`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "x-token": token,
            },
          }
        );
  
        const data = await response.json();
        //console.log("Fetched all subcategories:", data);
  
        if (data.success) {
          setProductSubcategories(data.data || []);
        } else {
          setProductSubcategories([]);
        }
      } catch (error) {
        console.error("❌ Error fetching subcategories for multiple categories:", error);
      }
     
    };
  
  
     const fetchProductsByCategoryIds = async (categoryIds) => {
      try {
        const response = await fetch(fetchUrl + "product/get-products-by-category-ids", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ categoryIds }),
        });
  
        const data = await response.json();
        //console.log("Fetched products by category IDs:", data);
  
        if (data.success) {
          setProducts(data.data || []);
        } else {
          setProducts([]);
        }
      } catch (error) {
        console.error("❌ Error fetching products by category IDs:", error);
      }
      
    };
  
/*   const fetchRecentlyViewed = async () => {
    try {
      const customerId = sessionStorage.getItem("customerId");
      const token = sessionStorage.getItem("token");
      if (!customerId || !token) return;
  
      const response = await fetch(
        `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/get-recently-viewed-customerId?customerId=${customerId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "x-token": token,
          },
        }
      );
  
      const data = await response.json();
      console.log("Recently Viewed:", data);
  
      if (data.success && Array.isArray(data.data)) {
        // map backend fields to frontend ActivityCard format
        const mapped = data.data.map((item) => ({
         ...item.productId
        }));
         setRecent(mapped.reverse());
      }
    } catch (err) {
      console.error("❌ Error fetching recently viewed:", err);
    }
   
  }; */
  
  
  const getCustomerDetails = async (customerId) => {
      const userData = JSON.parse(localStorage.getItem('userData'));
      const token = userData?.token || sessionStorage.getItem('token');
      
      try {
          const response = await fetch(`${url}customer/get-customer-by-customerId?customer_id=${customerId}`, {
              method: 'GET',
              headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json',
                  'x-token': token
              }
          });
          
          const result = await response.json();
          //console.log("Fetch customer response:", result);
          
          if (result.success) {
              setCustomerData(result.data);
              //console.log("Customer data fetched successfully:", result.data);
          } else {
              console.error('Failed to fetch customer:', result.message);
          }
      } catch (error) {
          console.error('Error:', error);
      }
  };
  
  const getBuildCoinsWallet = async () => {
      const userData = JSON.parse(localStorage.getItem('userData'));
      const token = userData?.token || sessionStorage.getItem('token');
      
      try {
          const response = await fetch(`${url}rewards/get-buildcoins-wallet?consumer_id=${userData._id}`, {
              method: 'GET',
              headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json',
                  'x-token': token
              }
          });
          
          const result = await response.json();
          //console.log("Fetch customer wallet response:", result);
          setWallet(result.data.buildcoins_wallet);
          //console.log("Customer wallet fetched successfully:", result.data);
      } catch (error) {
          console.error('Error:', error);
      } 
  };
  
  
  const getStats = async () => {
      const userData = JSON.parse(localStorage.getItem('userData'));
      const token = userData?.token || sessionStorage.getItem('token');
      
      try {
          const response = await fetch(`${url}customer/get-customer-order-value?consumer_id=${userData._id}`, {
              method: 'GET',
              headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json',
                  'x-token': token
              }
          });
          
          const result = await response.json();
          console.log("Fetch customer stats response:", result);
          //setStats(result.data);
          console.log("Customer stats fetched successfully:", result.data);
      } catch (error) {
          console.error('Error:', error);
      } 
  };
  
  const fetchCategories = async () => {
    try {
      const response = await fetch(
        fetchUrl + "product-category/get-all-productCategories?is_ecommerce=true",
        {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        }
      );
  
      const data = await response.json();
      //console.log("Fetched categories:", data);
  
      if (data.success) {
        setCategories(data.data);
        return data.data;  // ✅ return categories list
      } else {
        console.error("Failed to fetch categories:", data.message);
        setError("Failed to fetch categories");
        return [];  // ✅ return empty array on failure
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
      setError("Error fetching categories");
      return [];  // ✅ return empty array on error
    } 
    
  };
  
   const fetchLiveRfqs = async () => {
    try {
      setLoadingRfqs(true);
  
      // Get user info
        const userData = JSON.parse(sessionStorage.getItem('userData'));
      const userId = userData?._id;
      const token = userData?.token || sessionStorage.getItem('token');
      if (!userId) return;
  
      // Fetch RFQs from backend
      const res = await fetch(`${API_BASE}customer/rfq/get-rfqs-by-customer?customerId=${userId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token || '',
        },
      });
  
      const data = await res.json();
      console.log('Live RFQs fetched', data);
  
      // Check if backend returned an array
      if (data.success && Array.isArray(data.data)) {
        // Reverse array so latest RFQs show first
        //const reversedData = [...data.data].reverse();
        setLiveRfqs(data.data);
      } else {
        // Handle case when no data or unexpected structure
        setLiveRfqs([]);
        console.warn('fetchLiveRfqs: data.data is not an array', data.data);
      }
  
    } catch (err) {
      console.error('fetchLiveRfqs', err);
      setLiveRfqs([]); // fallback
    } finally {
      setLoadingRfqs(false);
    }
  };
  
  const fetchQuotationDetails = async () => {
    // const quotationId = localStorage.getItem("quotationId");
  
    const userData =
          JSON.parse(sessionStorage.getItem('userData')) ||
          JSON.parse(localStorage.getItem('userData'));
  
        if (!userData || !userData._id) {
          console.error('No customer data found');
          return;
        }
  
  
    try { 
      const token = sessionStorage.getItem("token");
  
      const response = await fetch(
        // `${fetchUrl}customer/quotations/get-quotation-by-its-id?quotation_id=${quotationId}`,
       `${fetchUrl}customer/quotations/get-quotations-by-customer?customer_id=${userData._id}`,
  
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "x-token": token,
          },
        }
      );
  
      const data = await response.json();
      //console.log("📦 Quotation details response:", data);
    setQuotationDetails(Array.isArray(data.data) ? data.data : []);  // ✅ Always array
  
      if (!(response.ok && data.success)) {
        console.error("❌ Failed to fetch details:", data.message);
      }
  
      return data; // return the data for use
    } catch (error) {
      console.error("🚨 Error in fetchQuotationDetails:", error);
    }
    
  };
  
  const fetchCustomerProjects = async () => {
    try {
      const userData = JSON.parse(sessionStorage.getItem('userData'));
      if (!userData || !userData._id) return;
  
      const token = userData?.token || sessionStorage.getItem("token");
      const customerId = userData._id;
  
      const response = await fetch(
        `${process.env.REACT_APP_FORE_APILINK}/projects/get-projects-by-customer?customer_id=${encodeURIComponent(customerId)}`,
        {
          method: 'GET',
          headers: {
            "Content-Type": "application/json",
            "x-token": token,
          },
        }
      );
  
      const result = await response.json();
      //console.log("Fetched customer projects:", result);
  
      if (result.success && Array.isArray(result.data)) {
        setProjectsList(result.data);
        setSelectedProject(result.data[0] || null); // Set first project as selected
      }
    } catch (error) {
      console.error(error);
    }
   
  };
  
  
    const handleCategoryClick = (category) => {
      navigate('/consumer/productlist', {
        state: { categoryId: category._id, categoryName: category.product_category_name },
      });
    };
  
  
    const handleViewBucket = () => {
      navigate('/consumer/cartpreview', { state: { } });
    };
  
  
  const fetchDeliveryAddresses = async () => {
    try {
      const userData = JSON.parse(sessionStorage.getItem('userData'));
      const customerId = userData?._id;
      const token = userData?.token;
  
      if (!customerId || !token) {
        console.error('Customer ID or token not found');
        return;
      }
  
      const response = await fetch(`${fetchUrl}customer/delivery-address/getDeliveryAddresses?customer_id=${customerId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token,
        }
      });
  
      const data = await response.json();
      
      if (data.success) {
        setDeliveryAddresses(data.data || []);
      } else {
        console.error('Failed to fetch delivery addresses:', data.message);
      }
    } catch (error) {
      console.error('Error fetching delivery addresses:', error);
    }finally{
     setShowLocationPopup(true)
    }
  };

   const getImageUrl = (imagePath) => {
    if (!imagePath) return null;
    const cleanPath = imagePath.startsWith("/") ? imagePath.substring(1) : imagePath;
    return `${process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES}${cleanPath}`;
  };

  const getStatusStyles = (status) => {
    switch (status?.toLowerCase()) {
      case "waiting for best prices":
        return {
          bg: "bg-yellow-50",
          text: "text-yellow-700",
          icon: faClock,
          border: "border-yellow-100",
        };
      case "final prices received":
        return {
          bg: "bg-green-50",
          text: "text-green-700",
          icon: faCheckCircle,
          border: "border-green-100",
        };
      case "order created successfully":
        return {
          bg: "bg-green-50",
          text: "text-green-700",
          icon: faCheckCircle,
          border: "border-green-100",
        };
      case "rfq expired":
      case "cancelled":
        return {
          bg: "bg-red-50",
          text: "text-red-700",
          icon: faExclamationTriangle,
          border: "border-red-100",
        };
      default:
        return {
          bg: "bg-gray-50",
          text: "text-gray-600",
          icon: faBox,
          border: "border-gray-100",
        };
    }
  };
  
  
  if (loading) {
    return (
      <div className="fixed inset-0 flex flex-col items-center justify-center  bg-opacity-70 backdrop-blur-sm z-50">
        {/* 🔴 Red spinning circle */}
        <div className="w-8 h-8 border-2 border-red-400 border-t-transparent rounded-full animate-spin"></div>
        
        {/* Text below loader */}
        <p className="mt-4 text-gray-400 text-xs">Loading Home...</p>
      </div>
    );
  }
  return (
    <div className="bg-gray-100 min-h-screen pb-20">
      <style>{`.scrollbar-hide::-webkit-scrollbar { display: none; } .scrollbar-hide { -ms-overflow-style: none; scrollbar-width: none; }`}</style>

    <div className="sticky top-0 z-30 bg-gray-100">

    {/* Deliver Section */}
<div className="flex items-center  justify-between px-3 py-2 mb-3 bg-white shadow-sm rounded-lg">
  {/* Left: Delivery Location */}
  <div className="flex items-center">
    {/* Icon */}
   <div className="w-11 h-11 flex items-center justify-center bg-red-50 rounded-md">
  <FaMapMarkerAlt className="w-5 h-5 text-red-600" 
   onClick={() => {
    setShowLocationPopup(true);
    fetchDeliveryAddresses();
  }}
  />
</div>


    {/* Text */}
    <div className="flex flex-col leading-tight ml-3"
     onClick={() => {
    setShowLocationPopup(true);
    fetchDeliveryAddresses();
  }}
    >
      {deliveryAddress ? (
        <>
          <span className="text-sm font-medium text-blue-950">
            {deliveryAddress?.address_type === "project"
              ? "Delivering to Project"
              : "Delivering to Address"}
          </span>

     {/* Project / Other Address Name + Pincode */}
<span
  className="text-xs font-medium text-gray-700 flex items-center cursor-pointer hover:underline hover:text-blue-950 transition-colors duration-200 max-w-[200px] truncate"

  title={
    deliveryAddress?.address_type === "project"
      ? deliveryAddress?.project_name
      : deliveryAddress?.area_sector_locality || "Unnamed Address"
  }
>
  {deliveryAddress?.address_type === "project"
    ? deliveryAddress?.project_name
    : deliveryAddress?.area_sector_locality || "Unnamed Address"}
  
  {deliveryAddress?.pincode && (
    <span className="ml-1 text-gray-500">– {deliveryAddress?.pincode}</span>
  )}
  <FaChevronDown className="ml-1 text-gray-600 text-[10px]" />
</span>

        </>
      ) : (
        <span
          className="text-sm text-[#448B32] font-medium flex items-center cursor-pointer hover:underline"
          onClick={() => {
            setShowLocationPopup(true);
            fetchDeliveryAddresses();
          }}
        >
          <FaPlusCircle className="mr-1 text-[#448B32]" />
          Choose delivery address
        </span>
      )}
    </div>
  </div>

  {/* Right: Action Icons */}
 
<div className="flex items-center space-x-1">
  {/* 🛒 Cart */}
  <div className="relative cursor-pointer" onClick={handleViewBucket}>
    <img src={Bucket} alt="Bucket" className="h-8 w-8 object-contain" />
    {Object.keys(bucketProducts).length > 0 && (
      <span className="absolute -top-1 -right-1 bg-red-500 text-white text-[10px] font-semibold rounded-full h-4 w-4 flex items-center justify-center">
        {Object.keys(bucketProducts).length}
      </span>
    )}
  </div>

  {/* 👤 User Profile */}
  <div
    className="cursor-pointer flex items-center justify-center w-8 h-8  hover:bg-gray-200 transition"
    onClick={() => navigate("/consumer/profileAccount")}
  >
    <FontAwesomeIcon icon={faUserCircle} className="text-gray-700 h-5 w-5" />
  </div>
</div>

</div>



      {/* Search Bar */}
 <div className="px-2">
  <div
    className="flex items-center bg-white rounded-md p-2.5 space-x-2 border border-gray-200 shadow-sm"
   onClick={() => {
  setIsProductSearchOpen(true);
  sessionStorage.setItem("overlayOpen", "true");
}} 
  >
    {/* 🔍 Search Icon */}
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-5 w-5 text-gray-500"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
      />
    </svg>

    {/* 📝 Search Input */}
    <div className="relative flex-1">
      <input
        type="text"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        onFocus={() => setIsSearchFocused(true)}
        className="w-full bg-transparent text-gray-800 text-sm focus:outline-none placeholder-transparent"
      />

      {!searchQuery && (
        <div className="absolute left-0 top-1/2 transform -translate-y-1/2 overflow-hidden h-5 pointer-events-none">
      <div
        className={`flex flex-col ${
          placeholderIndex === 0 ? "" : "transition-transform duration-700 ease-in-out"
        }`}
        style={{
          transform: `translateY(-${placeholderIndex * 20}px)`,
        }}
      >
        {[...placeholders, ...placeholders].map((text, i) => (
          <span
            key={i}
            className="text-gray-400 text-sm leading-5"
            style={{ height: "20px" }}
          >
            {text}
          </span>
        ))}
      </div>
    </div>
  )}

      </div>


    {/* 🎤 Voice Recognition */}
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={`h-5 w-5 ${isListening ? "text-gray-500" : "text-gray-500"} cursor-pointer`}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      onClick={(e) => {
        e.stopPropagation(); // Prevent search overlay opening
        startVoiceRecognition();
      }}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M12 1a3 3 0 00-3 3v6a3 3 0 006 0V4a3 3 0 00-3-3zM19 11a7 7 0 01-14 0m7 7v4m0 0h-4m4 0h4"
      />
    </svg>

    <div className="h-6 w-px bg-gray-300"></div>

    {/* 📋 List Icon */}
    <img
      src={listicon}
      alt="List Icon"
      className="h-6 w-6 object-contain cursor-pointer"
      onClick={(e) => {
        e.stopPropagation(); // Prevent search overlay opening
        setShowUMR(true); // Open your custom popup
      }}
    />
  </div>
</div>
</div>


      {/* Welcome */}
       <div className="px-3 mb-2 mt-4">
        <h1 className="text-sm font-bold text-gray-800">Welcome back, {customerData?.customer_name || userData?.customer_name || "HariKrishna"}!</h1>
        <p className="text-xs text-gray-600">Manage your procurement with ease.</p>
      </div> 

      {/* Stats */}
   


<div className="grid grid-cols-2 gap-3 mt-3 mb-2 px-3">

  {/* BuildCoins Card */}
  <div
    onClick={() => navigate("/consumer/bctrn")}
    className="bg-white rounded-xl shadow-sm p-4 flex flex-col items-start justify-center cursor-pointer transition hover:shadow-md"
  >
    {/* Header */}
    <div className="flex items-center justify-between w-full mb-1">
      <div className="flex items-center gap-2">
        <FontAwesomeIcon icon={faWallet} className="w-4 h-4 text-orange-500" />
        <h3 className="text-xs font-semibold text-gray-700">BuildCoins</h3>
      </div>
      <FontAwesomeIcon icon={faAngleRight} className="w-4 h-4 text-gray-400" />
    </div>

    {/* Main Value */}
    <div className="text-lg font-bold text-gray-900 flex items-start -ml-1.5">
    <img
  src={BCImg}
  alt="BuildCoin"
  className="w-8 h-7  rounded-md  p-0.5"
/>

     {(wallet?.available_coins || 0).toLocaleString('en-US')}
    </div>

    {/* Subtext */}
    <p className="text-xs text-gray-500 mt-1 text-center">BuildCoin Wallet</p>
    
    <div className="mt-1">
  <span className="text-[11px] font-medium text-orange-700">
     1 BuildCoin = ₹1
  </span>
</div>
</div>


  {/* Orders Card */}
  <div
    onClick={() => navigate("/consumer/orders")}
    className="bg-white rounded-xl shadow-sm p-4 flex flex-col items-start justify-center cursor-pointer transition hover:shadow-md"
  >
    {/* Header */}
    <div className="flex items-center justify-between w-full mb-1">
      <div className="flex items-center gap-2">
        <FontAwesomeIcon icon={faShoppingBag} className="w-4 h-4 text-green-500" />
        <h3 className="text-xs font-semibold text-gray-700">Orders</h3>
      </div>
      <FontAwesomeIcon icon={faAngleRight} className="w-4 h-4 text-gray-400" />
    </div>

    {/* Main Value */}
<div className="text-lg font-bold text-gray-900 flex items-center">
  <div className="flex items-center justify-center w-5 h-5 rounded-full bg-gradient-to-br from-green-500 to-emerald-600 shadow-sm mr-1">
    <FontAwesomeIcon
      icon={faIndianRupee}
      className="text-white w-3 h-3"
    />
  </div>
  {parseInt(stats.ordersValue, 10).toLocaleString("en-IN")}
</div>


    {/* Subtext */}
    <p className="text-xs text-gray-500 mt-1">5 Total Order(s)</p>

    {/* Highlighted Savings */}
    <div className="mt-1">
  <span className="text-[11px] font-medium text-green-700">
    Total Savings ₹{stats.totalSavings.toLocaleString("en-IN")}
  </span>
</div>

  </div>
</div>

{/* 🟦 FILTER VALID RFQS FIRST */}


{liveRfqs &&
  liveRfqs.filter(
    (r) =>
      !r.status?.toLowerCase().includes("cancelled") && 
      r.payment_status?.toLowerCase() !== "paid"
  ).length > 0 && (
    <div className="rounded-md mt-3 bg-transparent mb-2">

      {/* RFQ Header */}
      <div className="flex items-center justify-between px-3 mb-1">
        <h2 className="text-sm font-semibold">RFQs</h2>

        <button
          onClick={() => navigate("/consumer/app/rfqlist")}
          className="text-blue-700 text-xs underline font-semibold"
        >
          View All
        </button>
      </div>

      {/* RFQ Cards Section */}
      <div className="flex flex-col gap-1 px-3 relative">
        {loadingRfqs ? (
          <div className="absolute inset-0 flex flex-col items-center justify-center bg-white/70 backdrop-blur-sm z-10 rounded-md">
            <div className="w-8 h-8 border-2 border-red-400 border-t-transparent rounded-full animate-spin"></div>
            <p className="mt-4 text-gray-400 text-xs">Loading Home...</p>
          </div>
        ) : (
          <div className="flex gap-3 overflow-x-auto scrollbar-hide">
            {liveRfqs
              .filter(
                (r) =>
                  !r.status?.toLowerCase().includes("cancelled") &&
                  r.payment_status?.toLowerCase() !== "paid"
              )
              .map((rfq, idx) => {
                const images = rfq.items?.slice(0, 2) || [];
                const extra = rfq.items?.length > 2 ? rfq.items.length - 2 : 0;

                const getImageUrl = (imagePath) => {
                  if (!imagePath) return null;
                  const cleanPath = imagePath.startsWith("/")
                    ? imagePath.substring(1)
                    : imagePath;
                  return `${process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES}${cleanPath}`;
                };

                const statusStyles = {
                  waiting: "bg-yellow-50 text-yellow-700 border border-yellow-100",
                  final: "bg-green-50 text-green-700 border border-green-100",
                  order: "bg-blue-50 text-blue-700 border border-green-100",
                  cancelled: "bg-gray-50 text-gray-700 border border-gray-100",
                  default: "bg-gray-50 text-gray-600 border border-gray-100",
                };

                const getStatusStyle = (status) => {
                  if (!status) return statusStyles.waiting;
                  const s = status.toLowerCase();
                  if (s.includes("waiting")) return statusStyles.waiting;
                  if (s.includes("final")) return statusStyles.final;
                  if (s.includes("order")) return statusStyles.order;
                  if (s.includes("cancelled")) return statusStyles.cancelled;
                  return statusStyles.default;
                };

                const style = getStatusStyle(rfq.status);
                const status = rfq.status?.toLowerCase() || "";

                let buildCoinsToShow = 0;
                let messageLeft = "";
                let messageRight = "";

                if (status.includes("waiting")) {
                  buildCoinsToShow = rfq?.earned_build_coins || 0;
                  messageLeft =
                    buildCoinsToShow > 0 ? `Earn upto ${buildCoinsToShow}` : " ";
                  messageRight =
                    rfq?.total_savings > 0
                      ? `Savings ₹${rfq.total_savings?.toLocaleString("en-IN")}`
                      : " ";
                } else if (status.includes("order") || status.includes("final")) {
                  buildCoinsToShow = rfq?.earned_build_coins || 0;
                  messageLeft =
                    buildCoinsToShow > 0 ? `Earned ${buildCoinsToShow}` : " ";
                  messageRight =
                    rfq?.total_savings > 0
                      ? `Saved ₹${rfq.total_savings?.toLocaleString("en-IN")}`
                      : " ";
                }

                const handleCardClick = () => {
                  if (rfq?.quotation_id) {
                    navigate("/consumer/app/rfqdetails", {
                      state: {
                        rfq_id: rfq._id,
                        quotationId: rfq.quotation_id,
                      },
                    });
                  }
                };

                return (
                  <div
                    key={`rfq-${rfq._id || idx}`}
                    onClick={handleCardClick}
                    className="min-w-[220px] max-w-[220px] bg-white rounded-2xl border border-gray-200 shadow-sm p-3 flex flex-col justify-between flex-shrink-0 cursor-pointer hover:shadow-md hover:-translate-y-[2px] transition-all duration-150"
                  >
                    {/* Top Row */}
                    <div className="flex justify-between items-start mb-2">
                      <p className="text-[13px] font-semibold text-gray-900">
                        {rfq.rfq_number}
                      </p>

                      <div className="text-right">
                        <p className="text-[14px] font-bold text-gray-900">
                          ₹{rfq.estimated_total?.toLocaleString("en-IN")}
                        </p>
                        <p className="text-[11px] text-gray-500 leading-tight">
                          {rfq.status?.toLowerCase().includes("order") ||
                          rfq.status?.toLowerCase().includes("final")
                            ? "Final Price"
                            : "Estimated Value"}
                        </p>
                      </div>
                    </div>

                    {/* Images */}
                    <div className="flex items-center mt-1 mb-1">
                      {images.length > 0 ? (
                        <>
                          {images.map((img, i) => (
                            <div
                              key={i}
                              className="w-7 h-7 rounded-full overflow-hidden border-2 border-white"
                              style={{ marginLeft: i === 0 ? 0 : -8 }}
                            >
                              <img
                                src={getImageUrl(img.image)}
                                alt={img.id}
                                className="w-full h-full object-cover"
                              />
                            </div>
                          ))}
                          {extra > 0 && (
                            <div
                              className="w-7 h-7 rounded-full bg-gray-200 text-gray-600 text-[10px] flex items-center justify-center border-2 border-white"
                              style={{ marginLeft: -8 }}
                            >
                              +{extra}
                            </div>
                          )}
                        </>
                      ) : (
                        <div className="text-[10px] text-gray-400">No Image</div>
                      )}

                      <span className="ml-2 text-[12px] font-medium text-gray-700 truncate">
                        {rfq.product_categories?.length > 1
                          ? `${rfq.product_categories[0]?.product_category_name} & more`
                          : rfq.product_categories?.[0]?.product_category_name ||
                            "General"}
                      </span>
                    </div>

                    {/* Status */}
                    <div className={`rounded-lg ${style} px-2 py-1.5`}>
                      <p className="text-[12px] font-semibold truncate">
                        {rfq.status}
                      </p>
                      {rfq.status_message && (
                        <p className="text-[10px] truncate opacity-80">
                          {rfq.status_message}
                        </p>
                      )}
                    </div>

                    {/* Coins + Savings */}
                    <div className="flex justify-between items-center text-[11px] text-gray-700 mt-2 border-t border-gray-100 pt-1.5">
                      <span className="flex items-center ">
                        <span className="font-medium text-gray-500">
                          {messageLeft}
                        </span>
                        {buildCoinsToShow > 0 && (
                          <img
                            src={BCImg}
                            alt="BuildCoin"
                            className="w-4 h-4 object-contain opacity-80"
                          />
                        )}
                      </span>

                      <span className="text-green-700 font-medium">
                        {messageRight}
                      </span>
                    </div>
                  </div>
                );
              })}
          </div>
        )}
      </div>
    </div>
)}




      {/* Categories */} 
<div className="rounded-lg px-3 mt-2 mb-2">
  <h2 className="text-sm font-semibold mb-2">Categories</h2>

  <div className="grid grid-cols-3 gap-2">
    {categories.slice(0, 5).map((cat) => (
      <div
        key={cat._id}
        className="flex flex-col items-center justify-center p-3 bg-white rounded-lg shadow-md cursor-pointer hover:bg-gray-50 transition"
        onClick={() => {
          // ✅ Always show popup for every category
          setSelectedCategory(cat);
          setShowCategoryPopup(true);
          handleCategoryClick(cat)
        }}
      >
 <img
  src={
    cat.product_category_image
      ? `${process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES}/${cat.product_category_image}`
      : defaultimg
  }
  alt={cat.product_category_name}
  className={`h-14 w-14 object-cover mb-2 rounded-md ${
    cat.product_category_image ? "" : "bg-gray-100"
  }`}
/>

        <span className="text-xs text-gray-800 text-center font-medium">
          {cat.product_category_name}
        </span>
      </div>
    ))}

    {categories.length > 0 && (
      <div
        onClick={() => {
          navigate("/consumer/ProductCategories");
          window.scrollTo(0, 0);
        }}
        className="flex flex-col items-center justify-center p-3 bg-white rounded-lg shadow-md cursor-pointer hover:bg-gray-50 transition"
      >
        <div className="h-5 w-5 flex items-center justify-center rounded-full bg-gray-100 text-blue-400 font-bold mb-1">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-3 w-3"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 5l7 7-7 7"
            />
          </svg>
        </div>
        <span className="text-xs text-gray-800 text-center font-medium mt-2">
          View All
        </span>
      </div>
    )}
  </div>
</div>

    <div className="fixed bottom-0 left-0 right-0 bg-white shadow-md z-40 border-t border-gray-200">
  <MenuFooter />



{showLocationPopup && (
  <>
  <ChangeLocationPopup
   deliveryAddresses = {deliveryAddresses}
   deliveryAddress = {deliveryAddress}
   setDeliveryAddress= {setDeliveryAddress}
   setShowLocationPopup = {setShowLocationPopup}
  />
  </>
)}

  {showVoicePopup && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
    <div className="bg-white rounded-lg shadow-lg p-6 flex flex-col items-center max-w-xs w-full">
      <div className="mb-3">
       <img 
                 src={Microphone} 
                 alt="Listening" 
                 className={`w-12 h-12 ${isListening ? 'animate-pulse' : ''}`} 
               />
      </div>
      <div className="text-lg font-semibold mb-2 text-gray-900">
        {isListening ? "Listening..." : "Say a product name"}
      </div>
      <div className="text-sm text-gray-500 mb-4 text-center">
        Speak the product you want to search for.
      </div>
      <button
        onClick={() => {
          setIsListening(false);
          setShowVoicePopup(false);
        }}
        className="mt-2 px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 transition-colors"
      >
        Cancel
      </button>
    </div>
  </div>
)}

 <UMR 
        visible={showUMR}
        onClose={() => setShowUMR(false)}
        categories={categories}
         onRfqCreated={() => {
    fetchLiveRfqs();
    setActiveTab("buy"); 
  }}
  />


       {/* Project Quote Modal */}
      <ProjectQuoteModal
        visible={isQuoteModalVisible}
        onClose={() => setIsQuoteModalVisible(false)}
        projects={projectsList}
        selectedCategory={selectedCategory}
        brands={brands}
        onQuoteSubmit={handleQuoteSubmit}
      />

           <ProductSearchOverlay
                isOpen={isProductSearchOpen}
                onClose={() => setIsProductSearchOpen(false)}
              />
</div>

    </div>
  );

}
export default ProjectDetails;